import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

const FAQSection = () => {
  const faqs = [
    {
      question: "What is Diastasis Recti?",
      answer: "Diastasis Recti is a condition where the abdominal muscles (rectus abdominis) separate during pregnancy due to stretching of the connective tissue. It's very common, affecting about 60% of pregnant women, and can cause a visible bulge in the abdomen, back pain, and weakened core strength.",
    },
    {
      question: "Can Diastasis Recti heal without surgery?",
      answer: "Yes, in most cases Diastasis Recti can be effectively treated with structured physiotherapy and targeted exercises. Dr. Seema's evidence-based rehabilitation program has helped over 7000 women recover without surgery. Surgery is typically only considered in severe cases that don't respond to conservative treatment.",
    },
    {
      question: "How long does the treatment take?",
      answer: "Treatment duration varies based on the severity of the condition. Typically, our rehabilitation program runs for 8-16 weeks. Most patients start noticing improvement within the first few weeks of consistent treatment and home exercises.",
    },
    {
      question: "Is treatment safe after C-section?",
      answer: "Yes, our treatment is safe for women who have had C-sections. However, we recommend waiting at least 6-8 weeks post-surgery before starting rehabilitation, and always getting clearance from your obstetrician. Dr. Seema tailors the program based on your delivery type and recovery progress.",
    },
    {
      question: "What should I expect during my first consultation?",
      answer: "During your first visit, Dr. Seema will conduct a thorough assessment including measuring the gap between your abdominal muscles, evaluating your core stability, and understanding your symptoms and goals. Based on this, she'll create a personalized treatment plan for you.",
    },
    {
      question: "Will I need to come to the clinic every day?",
      answer: "No, typically patients visit the clinic 2-3 times per week for supervised sessions. You'll also receive a home exercise program to follow on other days. The frequency may vary based on your condition and progress.",
    },
  ];

  return (
    <section id="faq" className="section-spacing bg-white" data-testid="faq-section">
      <div className="section-container">
        <div className="max-w-3xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <span className="inline-block bg-pink-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
              Common Questions
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4" data-testid="faq-headline">
              Frequently Asked Questions
            </h2>
            <p className="text-stone-600">
              Get answers to common questions about Diastasis Recti and our treatment approach.
            </p>
          </div>

          {/* FAQ Accordion */}
          <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-stone-50 rounded-xl px-6 border-none"
                data-testid={`faq-item-${index}`}
              >
                <AccordionTrigger className="text-left font-semibold text-blue-900 hover:text-blue-700 py-5 hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-stone-600 pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {/* More Questions CTA */}
          <div className="text-center mt-10 p-6 bg-gradient-to-r from-pink-50 to-blue-50 rounded-2xl" data-testid="faq-cta">
            <p className="text-stone-700 mb-2">Still have questions?</p>
            <a
              href="https://wa.me/918800095625?text=Hi%2C%20I%20have%20a%20question%20about%20Diastasis%20Recti%20treatment"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-700 font-semibold hover:text-blue-800"
              data-testid="faq-whatsapp-link"
            >
              WhatsApp us directly for quick answers →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
